import { IconPresentationProps } from "@insite/mobius/Icon";
import * as React from "react";

const FileText: React.FC<IconPresentationProps> = props => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            role="img"
        >
            {props.title && <title>{props.title}</title>}
            <path d="M 0 0 L 0 24 L 24 24 L 24 0 L 0 0 z M 7.5 4 L 13.876953 4 C 14.273758 4 14.656304 4.1602109 14.9375 4.4414062 L 17.558594 7.0625 C 17.839789 7.3436952 17.998047 7.7281961 17.998047 8.125 L 17.998047 18.5 C 17.998047 19.327964 17.327965 20 16.5 20 L 7.5 20 C 6.672036 20 6.0019531 19.327964 6.0019531 18.5 L 6.0019531 5.5019531 C 6.0019531 4.6739892 6.672036 4.00311 7.5 4 z M 7.5 5.0019531 C 7.225059 5.0019531 7 5.2270126 7 5.5019531 L 7 18.5 C 7 18.77494 7.225059 19 7.5 19 L 16.5 19 C 16.77494 19 17 18.77494 17 18.5 L 17 9.0019531 L 13.75 9.0019531 C 13.334462 9.0019531 13 8.6674911 13 8.2519531 L 13 5.0019531 L 7.5 5.0019531 z M 14 5.0175781 L 14 8.0019531 L 16.984375 8.0019531 C 16.962498 7.9144762 16.917192 7.8371144 16.851562 7.7714844 L 14.230469 5.1503906 C 14.164838 5.08476 14.08748 5.0394551 14 5.0175781 z " />
        </svg>
    );
};

export default React.memo(FileText);
